import React from 'react'

import NavigationMenuSection from "../../../menu-items/section/section"
import NavigationMenuProjectsViewsItem from "./view-item"
import CustomView from '../../../../../core/model2/custom-view/custom-view'
import mainMenu_projectViews from "../../../actions/project-views";
import ProjectCollectionModel from "../../../../../core/model2/project-collection/project-collection-model";
import {EntityType} from "../../../../../core/gd/const/item";
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "../../../../../core/model2/project-collection/events";
import NavigationMenu_NewView from "../../../menu-items/menu-new-view/menu-new-view";
import {NavigationSectionType} from "../../../../../core/model2/navigation/@const"
import MainMenu_SectionReorderableWithMore from "../../../components/menu-controller/menu-section-reordable-with-more";

type Props = {

}

export default class NavigationMenuProjectsViewsV2 extends React.Component<Props> {

    constructor(props:Props) {
        super(props)
        gd.bus.subscribe('gd.session.customViews:change', this, this.update)
        gd.bus.subscribe(EVENT_BUS_SESSION_PORTFOLIO_CHANGED, this, this.forceUpdate);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    update = () => {
        this.forceUpdate()
    }

    onDragCustomViewsEnd = (items:any) => {
        gd.user.menu.projectsPortfolios.sortPositions =  _.map(items, item=>item.id)
        gd.user.menu.save()
    }

    renderViewsList(views:any) {
        const items:any[] = []

        _.map(views,        (view:CustomView|ProjectCollectionModel)=>{

            switch (view.entityType) {

                case EntityType.PORTFOLIO:
                    items.push({
                        type    : 'portfolio',
                        id      : 'p_{0}'.f(view.id),
                        data    : view
                    })
                    break

                case EntityType.CUSTOM_VIEW:
                default:
                    items.push({
                        type    : 'view',
                        id      : 'v_{0}'.f(view.id),
                        data    : view
                    })
                    break
            }
        })


        // sort by custom sort position if same by name
        const sortedItems = _.orderBy(items, [item=>{
            let sortPosition = _.indexOf(gd.user.menu.projectsPortfolios.sortPositions, item.id)
            if (sortPosition === -1) sortPosition = 999
            return sortPosition
        }, (item:any)=>item.name ? item.name.toLowerCase() : ''], ['asc', 'asc'])

        const components : any[] = _.map(sortedItems, (item:any)=>({
            item        : item,
            component   : <NavigationMenuProjectsViewsItem item={item} />
        }))

        return <MainMenu_SectionReorderableWithMore countVisibleItems   = {5}
                                                    moreTitle           = "All Views"
                                                    components          = {components}
                                                    settingsKey         = "project-custom-views"
                                                    onReorderEnd        = {this.onDragCustomViewsEnd}/>

        // return <ReorderList items={components} keyFunction={(item:any)=>item.id} onReorder={this.onDragCustomViewsEnd}/>
    }

    render() {

        const views = mainMenu_projectViews()

        return (
            <NavigationMenuSection name="Views" systemName="projectsViews" collapsible={true} counter={mainMenu_projectViews.length + 1}>
                {this.renderViewsList(views)}

                <NavigationMenu_NewView selectedGroupId          = 'portfolio'
                                        navigationSectionType    = {NavigationSectionType.PROJECTS}/>

            </NavigationMenuSection>
        )
    }
}
